/**
 * Common feature flags used by the Metrics feature
 */
export interface FeatureFlags {
  /**
   * Enables the Constant Comparisons feature.
   * Enabled in 21.2.
   */
  metricsReferenceLineEnabled: boolean;
  /**
   * Enables Color Status Indicators feature, as well as the associated redesign.
   * Enabled in 21.4.
   */
  metricsColorIndicatorsEnabled: boolean;
  /**
   * Enables date windows configured at authoring time.
   * Enabled in 21.4.
   */
  metricsDateWindowEnabled: boolean;
  /**
   * Enables custom historical comparisons configured at authoring time.
   * Enabled in 21.4
   */
  metricsHistoricalComparisonsEnabled: boolean;
  /**
   * Enables the window switcher on the detail screen. Currently should have the
   * same value as the editing flag, but named separately in case the window switcher
   * is not finished in time.
   * Enabled in 22.2
   */
  metricsWindowSwitcherEnabled?: boolean;
}

/**
 * Default values for `FeatureFlags`
 */
export const DefaultFeatureFlags: FeatureFlags = {
  metricsDateWindowEnabled: true,
  metricsReferenceLineEnabled: true,
  metricsColorIndicatorsEnabled: true,
  metricsHistoricalComparisonsEnabled: true,
  metricsWindowSwitcherEnabled: true,
};
